<script setup lang="ts">
import { UIIcon } from '@groover-dev/groover-ui'

import InfluencerTextBadge from '~/components/influencer/profile/header/TextBadge.vue'

import type { Influencer } from '~/types/influencer'

type Props = {
  influencer: Influencer
  userIsOwner: boolean
  imgSrc: string
  kinds: string
  country?: string
  isContest?: boolean
}

type Emits = {
  editBanner: []
}

const {
  userIsOwner,
  country = undefined,
  isContest = false,
} = defineProps<Props>()
const emit = defineEmits<Emits>()
</script>

<template>
  <div
    class="mainParentContainer tw-relative !tw-hidden tw-w-full tw-items-end tw-pb-6 lg:!tw-flex"
  >
    <div class="tw-relative tw-mr-6 tw-h-20 tw-w-40 tw-shrink-0">
      <div
        class="tw-absolute tw-left-0 tw-top-0 tw-size-40 tw-overflow-hidden tw-rounded-full tw-shadow"
        :class="{
          'tw-rounded-xs tw-shadow-[shadow:0_1px_4px_0_rgba(51,51,51,0.1)]':
            isContest,
        }"
      >
        <img
          :src="imgSrc"
          alt=""
          class="tw-size-full tw-object-cover tw-object-center"
        />
      </div>
    </div>
    <div class="tw-ellipsis tw-flex tw-w-full tw-flex-col">
      <div class="tw-relative tw-mb-2 tw-flex tw-items-center">
        <h1
          class="tw-ellipsis tw-text-h5 tw-w-auto tw-max-w-[calc(100%-100px)] tw-text-white"
        >
          {{ influencer.entity }}
        </h1>
        <InfluencerTextBadge :influencer="influencer" />
      </div>
      <div class="tw-flex tw-items-center">
        <span
          class="tw-ellipsis tw-text-left tw-text-base tw-font-bold tw-capitalize tw-text-white"
          >{{ kinds }}</span
        >
        <span
          v-if="country"
          class="tw-mx-1 tw-text-base tw-font-bold tw-text-white"
          >·</span
        >
        <span class="tw-text-sm tw-font-bold tw-text-white">{{ country }}</span>
      </div>
    </div>
    <!-- ClientOnly used to keep dynamic content out of cdn cache -->
    <ClientOnly>
      <button
        v-if="userIsOwner"
        type="button"
        class="tw-mb-5 tw-ml-4 tw-hidden tw-h-5 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center lg:tw-flex"
        @click="emit('editBanner')"
      >
        <UIIcon
          name="fa-solid:edit"
          class="tw-mr-1 tw-text-white tw-opacity-75"
          size="sm"
        />
        <span class="tw-text-sm tw-font-medium tw-text-white tw-opacity-75">{{
          $t('influencer.profile.slug.profile.nav06')
        }}</span>
      </button>
    </ClientOnly>
  </div>
</template>
